import { ETagIntents, ETagToneIntents } from '@src/typings';
import { cva } from 'class-variance-authority';

export const TagVariants = cva('shadow-sm', {
    variants: {
        format: {
            [ETagIntents.filled]: 'rounded transition-all ease-out',
            [ETagIntents.light]: 'rounded transition-all ease-out',
            [ETagIntents.linear]: 'rounded transition-all ease-out',
        },
        size: {
            xs: 'text-xs leading-3 py-1',
            sm: 'text-xs leading-3 py-1',
            md: 'text-base',
            lg: 'text-base',
            xl: 'text-base',
        },
        tone: {
            [ETagToneIntents.Natural]: '',
            [ETagToneIntents.Positive]: '',
            [ETagToneIntents.Negative]: '',
            [ETagToneIntents.Warning]: '',
            [ETagToneIntents.Primary]: '',
        },
    },
    defaultVariants: {
        format: ETagIntents.filled,
        tone: ETagToneIntents.Primary,
        size: 'md',
    },
});
